import React from 'react';
import { motion } from 'framer-motion';
export function CostOfInaction() {
  const costs = [{
    bad: 'Noches buscando en Google sin respuestas concretas',
    cost: 'Horas de tu vida por semana'
  }, {
    bad: 'Hijo sin rutinas claras',
    cost: 'Crisis diarias evitables'
  }, {
    bad: 'Sin protocolo de emergencia',
    cost: 'Cada crisis te desborda más'
  }, {
    bad: 'Sin comunicación efectiva con la escuela',
    cost: 'Oportunidades de apoyo perdidas'
  }, {
    bad: 'Sin herramientas de autoestima',
    cost: 'Identidad negativa que se consolida'
  }, {
    bad: 'Sin guía de alimentación',
    cost: 'Gatillos invisibles que amplifican los síntomas'
  }, {
    bad: 'Cada noche buscando respuestas sueltas',
    cost: 'El mismo ciclo el próximo año'
  }];
  return <section className="py-24 px-4 bg-slate-950 border-t border-red-500/20 relative overflow-hidden" data-id="element-30">
      <div className="absolute bottom-0 left-0 w-full h-[500px] bg-red-500/5 blur-[100px] pointer-events-none" data-id="element-31" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-black text-white text-center mb-12" data-id="element-33">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-slate-900 border border-slate-800 rounded-3xl overflow-hidden mb-16" data-id="element-34">
          <table className="w-full text-left" data-id="element-35">
            <thead data-id="element-36">
              <tr className="bg-slate-950 border-b border-slate-800" data-id="element-37">
                <th className="p-4 text-slate-400 font-bold w-1/2" data-id="element-38">
                  Sin el Combo
                </th>
                <th className="p-4 text-red-400 font-bold w-1/2 border-l border-slate-800" data-id="element-39">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/50" data-id="element-40">
              {costs.map((row, i) => <tr key={i} className="hover:bg-slate-800/50 transition-colors" data-id="element-41">
                  <td className="p-4 text-slate-300" data-id="element-42">{row.bad}</td>
                  <td className="p-4 text-white font-bold border-l border-slate-800" data-id="element-43">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-44">
          <p className="text-2xl md:text-3xl font-black text-white mb-4" data-id="element-45">
            El próximo lunes puede ser diferente.
          </p>
          <p className="text-xl text-amber-400 font-bold italic" data-id="element-46">
            "La próxima semana puede ser la mejor que vivieron como familia." 💛
          </p>
        </div>
      </div>
    </section>;
}